<template>
  <section class="jps-curation-search-box" v-if="ss">
    <UiCsearchHeader v-if="def.mode === 'NORMAL'" :cs="cs" />
    <SearchBox :ss="ss" :no-detail="noDetail" />

    <BaseContainerSpread>
      <UiItemSearchResult
        v-if="def.dataType === 'item'"
        :ss="ss"
      />
      <UiCurationSearchResult
        v-if="def.dataType === 'curation'"
        :ss="ss"
      />
    </BaseContainerSpread>
  </section>
</template>

<script lang="ts" setup>
const { getCustomSearch } = useCustomSearch()
const { getSearchId, testCustomSearch } = useItem()
const { searchCuration } = useCuration()

interface Props {
  def: PartSearchBox
}
const props = withDefaults(defineProps<Props>(), {})

const noDetail = computed(() => {
  return props.def.mode === 'KEYWORD'
})

const cs: Ref<CustomSearchDefinition> = ref(null)
const ss: Ref<SearchStore<any>> = ref(null)
const setup = async () => {
  if (props.def.csId) {
    cs.value = await getCustomSearch(props.def.csId)
    if (props.def.dataType === 'item') {
      ss.value = useSearch<Item>(cs.value, getSearchId(cs.value.id), { configSyncRoute: false })
    } else if (props.def.dataType === 'curation') {
      ss.value = useSearch<Curation>(cs.value, searchCuration, { configSyncRoute: false })
    }
    ss.value.restoreQuery()
  } else if (props.def.searchDef) {
    cs.value = props.def.searchDef
    ss.value = useSearch<Item>(cs.value, testCustomSearch(cs.value), { configSyncRoute: false })
    ss.value.restoreQuery()
  }
}

onBeforeMount(() => {
  setup()
  watch(
    () => props.def.csId,
    () => setup()
  )
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-curation-search-box {
  background: $white;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;

  // .jps-cs-header {
  //   @include base-content-width();
  //   margin-bottom: 1.5rem;
  // }
  .jps-search-box {
    @include base-content-width();
    margin-bottom: 1rem;
  }
  .item-search-result {
    @include margin-full-width();
  }

  > .search-box {
    /* border-bottom: 1px solid $jps-gray-300; */
    @include is-mobile {
      padding: 0 1rem;
    }
    @include is-tablet {
      max-width: lcuration-content-width;
      margin: auto;
    }
  }
  .view-mode {
    margin-top: 1em;
    margin-bottom: 1em;
  }
  .jps-searchdef {
    padding-bottom: 1rem;
    border-bottom: 1px dashed $jps-gray-300;
    margin: 1rem 0;
    @include is-mobile {
      padding-bottom: 0.5rem;
      margin: 0 1rem;
    }
  }

  .search-parts {
    display: flex;
    margin-bottom: 1em;
    .search-paginaition {
      flex-grow: 1;
    }
  }

  .result {
    margin-top: 1em;
    position: relative;
    width: 100%;
    height: 100%;
  }
  .search-result-table {
    overflow-x: scroll;
  }

  .curation-search-result {
  }

  .panel-result {
    display: flex;
    .facets {
      flex-basis: 25%;
      margin-right: 2em;
      .search-facet {
        margin-top: 1em;
      }
    }
    .search-result-panel {
      flex-grow: 1;
    }
  }
}
</style>
